/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Tile_Login_TitleInputs */

const en_home_hero_tile_login_title = /** @type {(inputs: Home_Hero_Tile_Login_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login to Member Portal`)
};

const fr_home_hero_tile_login_title = /** @type {(inputs: Home_Hero_Tile_Login_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter au portail membre`)
};

/**
* | output |
* | --- |
* | "Login to Member Portal" |
*
* @param {Home_Hero_Tile_Login_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_hero_tile_login_title = /** @type {((inputs?: Home_Hero_Tile_Login_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Tile_Login_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_tile_login_title(inputs)
	return fr_home_hero_tile_login_title(inputs)
});